import { fetcher } from "helpers/fetcher";

import {
  TDeleteJobListingRequirementsReq,
  TDeleteJobListingRequirementsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteJobListingCertification = async (
  payload: TDeleteJobListingRequirementsReq
) => {
  return await fetcher<
    TDeleteJobListingRequirementsRes,
    TDeleteJobListingRequirementsReq["data"]
  >(ENDPOINT.CORPORATION.DELETE_JOB_LISTING_CERTIFICATION, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.DELETE_JOB_LISTING_CERTIFICATION.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationDeleteJobListingCertification = async (
  payload: TDeleteJobListingRequirementsReq
) => {
  return (await deleteJobListingCertification(payload)).data;
};

mutationDeleteJobListingCertification._key = (
  payload: TDeleteJobListingRequirementsReq
) => [ENDPOINT.CORPORATION.DELETE_JOB_LISTING_CERTIFICATION.url, payload];
